/**
 * Uploads a file to a given URL using XMLHttpRequest
 * @param url url to be uploaded to
 * @param file file to be uploaded
 * @param options callbacks for various eventss
 */
const uploadFile = (
  url: string,
  file: File,
  options: {
    onError?: XMLHttpRequestEventTarget['onerror'];
    onProgress?:
      | ((
          this: XMLHttpRequest,
          ev: ProgressEvent,
          uploadedPercentage: number
        ) => void)
      | null;
    onUploadComplete?: () => void;
  }
) => {
  const xhr = new XMLHttpRequest();
  xhr.open('PUT', url, true);
  xhr.setRequestHeader('Content-Type', file.type);
  xhr.onerror = options?.onError ?? function () {};
  xhr.upload.onprogress = (event) => {
    const uploadedPercentage = parseFloat(
      ((event.loaded / event.total) * 100).toFixed(2)
    );
    options.onProgress?.call(xhr, event, uploadedPercentage);
  };
  xhr.onreadystatechange = function () {
    if (xhr.readyState === xhr.DONE) {
      options.onUploadComplete?.();
    }
  };
  xhr.send(file);
};

export default uploadFile;
